import { ActionTree, MutationTree, GetterTree } from "vuex"

import { RootState } from "~/store"

export interface ExistingUser {
  email: string
  picture: string
  first_name: string
  is_facebook: boolean
}

export const state = () => ({
  display: false,
  displayRecovery: false,
  swap_mode: false,
  swap_email: "",
  existing_user: {
    email: "",
    picture: "",
    first_name: "",
    is_facebook: false,
  } as ExistingUser,
})
export type LoginState = ReturnType<typeof state>

export const mutations: MutationTree<LoginState> = {
  HIDE: function (state) {
    state.display = false
  },
  DISPLAY: function (state) {
    state.display = true
  },
  RESET_EXISTING_USER: function (state) {
    state.existing_user.email = ""
    state.existing_user.picture = ""
    state.existing_user.first_name = ""
    state.existing_user.is_facebook = false
  },
  SET_SWAP_EMAIL: function (state, data: string) {
    state.swap_email = data
  },
  SET_SWAP_MODE: function (state, data: boolean) {
    state.swap_mode = data
  },
  SET_DISPLAY_RECOVERY: function (state, data: boolean) {
    state.displayRecovery = data
  },
  SET_EXISTING_USER: function (state, data: ExistingUser) {
    state.existing_user.email = data.email
    state.existing_user.picture = data.picture
    state.existing_user.first_name = data.first_name
    state.existing_user.is_facebook = data.is_facebook
  },
}

export const actions: ActionTree<LoginState, RootState> = {
  IMPORT_EXISTING_USER: function ({ commit, dispatch }, data: ExistingUser) {
    commit("SET_EXISTING_USER", data)
    dispatch("SET_DISPLAY", true)
  },
  REQUEST_ACCOUNT_SWAP: function (
    { commit, dispatch },
    data: string | undefined
  ) {
    commit("SET_SWAP_MODE", true)
    commit("SET_SWAP_EMAIL", typeof data === "string" ? data : "")
    dispatch("SET_DISPLAY", true)
  },
  SET_DISPLAY: function ({ commit }, data: boolean) {
    if (data) {
      commit("band_signup/HIDE", null, { root: true })
      commit("DISPLAY")
    } else {
      commit("SET_SWAP_MODE", false)
      commit("SET_DISPLAY_RECOVERY", false)
      commit("SET_SWAP_EMAIL", "")
      commit("HIDE")
    }
  },
}

export const getters: GetterTree<LoginState, RootState> = {
  EXISTING_USER_IS_VALID: function (state) {
    return state.existing_user.email.length > 0
  },
}
